import React, { useState, useEffect } from 'react';

const Countdown = ({ targetDate = '2026-06-05T00:00:00' }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const difference = +new Date(targetDate) - +new Date();
            let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

            if (difference > 0) {
                timeLeft = {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                };
            }
            return timeLeft;
        };

        setTimeLeft(calculateTimeLeft());
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const TimeUnit = ({ value, label }) => (
        <div className="flex flex-col items-center">
            <div className="w-16 h-20 sm:w-20 sm:h-24 rounded-2xl border-2 border-purple-500/50 bg-[#1c0042]/80 backdrop-blur-sm flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.4)] mb-2">
                <span className="text-3xl sm:text-4xl font-black text-white">{value.toString().padStart(2, '0')}</span>
            </div>
            <span className="text-[10px] sm:text-xs text-orange-400 font-bold uppercase tracking-widest">{label}</span>
        </div>
    );

    return (
        <div className="flex justify-center gap-3 sm:gap-4 my-8">
            <TimeUnit value={timeLeft.days} label="Días" />
            <TimeUnit value={timeLeft.hours} label="Horas" />
            <TimeUnit value={timeLeft.minutes} label="Minutos" />
            <TimeUnit value={timeLeft.seconds} label="Segundos" />
        </div>
    );
};

export default Countdown;
